import React from 'react'
import { TriStateCheckbox } from 'primereact/tristatecheckbox'

const BooleanFilterTemplate = ({ options }) => {
    return (
        <div className="d-flex align-items-center">
            <TriStateCheckbox
                value={options.value}
                onChange={(e) => options.filterCallback(e.value, options.index)}
            />
        </div>
    )
}

export default BooleanFilterTemplate
